export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-white">
              移动端入口
            </h2>
            <p className="mt-3 text-white/80 text-sm md:text-base leading-relaxed max-w-md mx-auto lg:mx-0">
              今日看料已全面适配移动端浏览器，无需下载安装，手机打开即可享受与桌面端一致的流畅导航体验。
              收藏本站到手机主屏幕，随时随地发现精彩内容。
            </p>
            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 px-5 py-3 rounded-full bg-white/15 text-white text-sm font-medium cursor-default">
                <i className="ri-smartphone-line text-lg"></i>
                <span className="whitespace-nowrap">手机浏览器直接访问</span>
              </div>
              <div className="flex items-center gap-2 px-5 py-3 rounded-full bg-white/15 text-white text-sm font-medium cursor-default">
                <i className="ri-qr-code-line text-lg"></i>
                <span className="whitespace-nowrap">扫描二维码直达</span>
              </div>
            </div>
          </div>
          <div className="w-40 h-40 md:w-48 md:h-48 rounded-2xl bg-white/10 flex items-center justify-center shrink-0">
            <i className="ri-smartphone-line text-6xl text-white/60"></i>
          </div>
        </div>
      </div>
    </section>
  );
}